if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
          const maxOrderQuantity = Number.parseInt(
            this.dataset.maxOrderQuantity || '0',
            10
          );

          if (maxOrderQuantity > 0) {
            this.submitButton.setAttribute('aria-disabled', true);

            try {
              const pendingFormData = new FormData(this.form);
              const variantId = Number.parseInt(pendingFormData.get('id'), 10);
              const requestedQuantity = Number.parseInt(
                pendingFormData.get('quantity') || '1',
                10
              );

              const cartResponse = await fetch('/cart.js', {
                headers: {
                  Accept: 'application/json',
                },
              });

              if (!cartResponse.ok) {
                throw new Error('Impossible de récupérer le panier');
              }

              const currentCart = await cartResponse.json();

              const currentQuantity = currentCart.items
                .filter((item) => Number(item.variant_id) === variantId)
                .reduce((total, item) => total + item.quantity, 0);

              if (currentQuantity + requestedQuantity > maxOrderQuantity) {
                const remainingQuantity = Math.max(
                  maxOrderQuantity - currentQuantity,
                  0
                );

                const limitMessage =
                  remainingQuantity > 0
                    ? `Cette référence est limitée à ${maxOrderQuantity} unités par commande. Vous pouvez encore en ajouter ${remainingQuantity}.`
                    : `Vous avez atteint la limite de ${maxOrderQuantity} unités par commande pour cette référence.`;

                this.handleErrorMessage(limitMessage);
                this.submitButton.removeAttribute('aria-disabled');
                return;
              }
            } catch (error) {
              console.error('Erreur lors de la vérification de quantité :', error);
              this.handleErrorMessage(
                'Impossible de vérifier la quantité disponible. Veuillez réessayer.'
              );
              this.submitButton.removeAttribute('aria-disabled');
              return;
            }
          }
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

				const setQuickAddButtonsState = (disabled = true) => {
					this.closest('.cart__samples')
						?.querySelectorAll('.quick-add__submit')
						.forEach((element) => {
							element.setAttribute('aria-disabled', disabled);
						});
				};

				if (this.form.querySelector(`[name="properties[_sample]"]`)?.value === 'true') {
					setQuickAddButtonsState(true);
				}

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.section),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
						
						if (this.form.querySelector(`[name="properties[_sample]"]`)?.value === 'true') {
							setQuickAddButtonsState(false);
						}
            
            fetch('/cart.js')
              .then(res => res.json())
              .then(cart => {
                if (cart.items.length === 0) return;
                const firstLineItem = cart.items[0];
                fetch('/cart/change', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    line: 1,
                    quantity: firstLineItem.quantity,
                  })
                })
                .then(r => r.json())
            });
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]') || this.form.querySelector('[name="items[0][id]"]');
      }
    }
  );
}
